"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getInitialState = (def, data, sortAttribute, sortDescAsc, filters) => ({
    data: data ? data : [],
    filters: filters || {},
    loading: false,
    numberOfTotalRows: data && data.length ? data.length : 0,
    sortAttribute,
    sortDescAsc: sortDescAsc !== undefined ? sortDescAsc : true,
    pageIdx: 1
});
exports.default = getInitialState;
